import React, {Component} from 'react';
import {Modal, Button} from 'react-bootstrap';
import Form from './Form';

const isUndefined = (obj) => typeof obj === 'undefined'
	? true
	: false

const Parse = require("parse");

class FormContainer extends Component {
	constructor(props, state) {
		super(props, state)
		this.getButtons = this.getButtons.bind(this)
		this.saveForm = this.saveForm.bind(this);
		this.stateSetter = this.stateSetter.bind(this);

		this.state = {
			isLoadingAction: false,
			selectedDataPointer: {},
			selectedDataBoolean: {},
			selectedParseFile: {}
		}
	}

	saveForm(parseObject) {
		let {
			handleModalShow,
			getTableData,
			formType,
			moduleCreate,
			moduleUpdate,
			moduleDelete,
			saveTrail,
			useMasterKey
		} = this.props

		useMasterKey = !isUndefined(useMasterKey) && typeof useMasterKey === "boolean" ? useMasterKey : false;

		console.log(this.props)

		console.log('parseObject', parseObject);

		var changesKey = parseObject.dirtyKeys();

		if (!isUndefined(moduleCreate) && formType.toUpperCase() === 'CREATE') {
			parseObject = moduleCreate(parseObject);
		} else if (!isUndefined(moduleUpdate) && formType.toUpperCase() === 'UPDATE') {
			parseObject = moduleUpdate(parseObject);
		} else if (!isUndefined(moduleDelete) && formType.toUpperCase() === 'DELETE') {
			parseObject = moduleDelete(parseObject);
		}

		if (parseObject) {
			this.setState({isLoadingAction: true});
			this.getSaveFirstObjects(parseObject).then((_parseObject) => {
				return (formType.toUpperCase() === 'DELETE'
					? _parseObject.destroy({ useMasterKey: useMasterKey })
					: _parseObject.save(null, { useMasterKey: useMasterKey }))
			}).then((data) => {
				console.log('data saved!');
				if (formType.toUpperCase() === 'DELETE') {
					changesKey = {};
					for (var key in data.attributes) {
						if (key != 'createdAt' && key != 'updatedAt') {
							changesKey[key] = data.attributes[key];
						}
					}
				} else {
					var objects = {};
					objects.objectId = data.id
					for (var key of changesKey) {
						objects[key] = data.get(key);
					}
					changesKey = objects;
				}

				if (typeof saveTrail !== 'undefined') {
					saveTrail(formType.toUpperCase(), changesKey);
				}

				handleModalShow('');
				getTableData();
				this.setState({isLoadingAction: false});
			}).catch((err) => {
				console.log('err', err)
				this.setState({isLoadingAction: false})
			})
		}
	}

	getSaveFirstObjects(parseObject) {
		let {formType, schema} = this.props
		return new Promise((resolve, reject) => {
			if (!formType.toUpperCase() !== 'DELETE') {
				let changesKey = parseObject.dirtyKeys();
				let toBeSave = []
				for (var key of changesKey) {
					const exist = schema.columns.map(e => e.type.toUpperCase() === 'PARSEFILE'
						? e.columnName
						: '').indexOf(key) != -1;
					if (exist && !isUndefined(parseObject.get(key)) && !isUndefined(parseObject.get(key).preview)) {
						toBeSave.push(key)
						let file = new Parse.File(parseObject.get(key).name, parseObject.get(key))
						toBeSave.push(file.save())
					}
				}
				if (toBeSave.length > 0) {
					Parse.Promise.when(toBeSave).then((datas) => {
						for (var i = 0; i < datas.length; i += 2) {
							parseObject.set(datas[i], datas[i + 1])
						}
						console.log('parseObject',parseObject)
						console.log('resolving...')
						resolve(parseObject)
					}).catch((err) => {
						console.log('err', err)
						reject(err)
					})
				} else {
					resolve(parseObject)
				}
			} else {
				resolve(parseObject)
			}
		})
	}

	getButtons() {
		let {formType, handleModalShow, selectedData} = this.props
		let {isLoadingAction} = this.state

		const iconStyle = {
			display: isLoadingAction
				? 'inline-block'
				: 'none',
			marginRight: '5px',
			color: 'white'
		}

		let buttons = [];
		formType.toUpperCase() !== 'DELETE' && formType.toUpperCase() !== 'VIEW' && formType.toUpperCase() !== ''
			? buttons.push(
				<Button onClick={() => handleModalShow('')}>CLOSE</Button>
			)
			: ''
		formType.toUpperCase() !== 'VIEW' && formType.toUpperCase() !== ''
			? buttons.push(
				<Button disabled={isLoadingAction} bsStyle="primary" onClick={() => this.saveForm(selectedData)}>
					<i style={iconStyle} className="fa fa-spinner fa-spin"></i>{formType.toUpperCase()}</Button>
			)
			: ''

		return (buttons)
	}

	stateSetter(stateArray) {
		for (var i = 0; i < stateArray.length; i++) {
			this.setState({
				[stateArray[i]['state']]: stateArray[i]['value']
			});
		}
	}

	render() {
		let {
			modalShow,
			handleModalShow,
			schema,
			formType,
			selectedData,
			loadOptions
		} = this.props

		let formState = {
			formType,
			selectedData,
			schema,
			loadOptions,
			selectedDataPointer: this.state.selectedDataPointer,
			selectedDataBoolean: this.state.selectedDataBoolean,
			selectedParseFile: this.state.selectedParseFile,
			stateSetter: this.stateSetter
		}

		return (
			<Modal show={modalShow} onHide={() => handleModalShow('')} keyboard autoFocus backdrop>
				<Modal.Header closeButton>
					<Modal.Title>{formType.toUpperCase()}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form {...formState}/>
				</Modal.Body>
				<Modal.Footer>
					{this.getButtons()}
				</Modal.Footer>
			</Modal>
		)
	}
}

export default FormContainer



// WEBPACK FOOTER //
// ./components/zynappse-crud/FormContainer.js